import Vue from "vue";
import {
    Drawer,
    DatePicker,
    TimeSelect,
    Select,
    Option,
    Input,
    Transfer,
    Switch,
    Pagination,
    Popover,
    Table,
    TableColumn,
    Button,
    Menu,
    MenuItem,
    RadioGroup,
    RadioButton,
    Loading,
    Cascader,
    Checkbox,
    CheckboxGroup,
    Dialog,
    MessageBox
} from "element-ui";

// 手动引入图标样式
import "../assets/css/theme/icon.css";
// 引入主题样式
import "../assets/css/theme/index.css";

// 注册组件
Vue.component(Drawer.name, Drawer);
Vue.component(DatePicker.name, DatePicker);
Vue.component(TimeSelect.name, TimeSelect);
Vue.component(Switch.name, Switch);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(Input.name, Input);
Vue.component(Transfer.name, Transfer);
Vue.component(Pagination.name, Pagination);
Vue.component(Popover.name, Popover);
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);
Vue.component(Button.name, Button);
Vue.component(Menu.name, Menu);
Vue.component(MenuItem.name, MenuItem);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(RadioButton.name, RadioButton);
Vue.component(Cascader.name, Cascader);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxGroup.name, CheckboxGroup);
Vue.component(Dialog.name, Dialog);
// 注册指令
Vue.use(Loading.directive);
// 注册 MessageBox
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;    